import { useCallback } from 'react';
import { useNotifier } from '@provider/notifier';
import { makeShareRevisionModalConfig } from '../modals/share/modal.js';

function useShareRevision() {
  const notifier = useNotifier();
  return useCallback(async revision => {
    return await notifier.modal(makeShareRevisionModalConfig(revision));
  }, [notifier]);
}

export { useShareRevision };
//# sourceMappingURL=share.js.map
